module.exports = __webpack_public_path__ + "media/images/admin/search-164949308dca14f9d4815e9448c9963d.svg";